// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7de7777c","498":"51c903e9","513":"7b1c9618","787":"bbf10fce"}[chunkId] + ".chunk.js";
};